import React, { useEffect, useState } from 'react'
import upload from '../../Image/upload.png';
import workpermit from '../../Image/KbIYw3csEXcJqNmDZRoGJkBHEry4Izk0.webp'
import HomeServices from '../../Services/HomeServices';
import toast from 'react-hot-toast';
import HttpClientXml from '../../utils/HttpClientXml';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
const PaymentHistory = () => {
  const { user } = useSelector(state => state.auth);
  const [imageUpload, setImageUpload] = useState(false)
  const [allData, setAllData] = useState([])

  console.log("GFD13",user);
  

  const fetchData = async () => {
    try {
      const res = await HomeServices.getPaymentHistory();
      console.log("CXS19", res.data);
      // return
      if (res && res.status) {
        setAllData(res.data)
      } else {
      }
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      <div class="accordion" id="accordionExample">
        {
          allData
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            .map((item, key) => {
              return (
                <>
                  <div class="accordion-item" key={key}>
                    <h2 class="accordion-header" id={`heading${key}`}>
                      <button class="accordion-button multi-line-btn" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${key}`} aria-expanded="true" aria-controls="collapseOne"
                      style={{fontSize:"22px"}}
                      >
                        Payment is {item?.paymentStatus||""}
                      </button>
                    </h2>
                    <div 
                    id={`collapse${key}`}
                      // class="accordion-collapse collapse show" 
                      className={key === 0 ? "accordion-collapse collapse show" : "accordion-collapse collapse"}
                      aria-labelledby={`heading${key}`} data-bs-parent="#accordionExample">
                      <div class="accordion-body">
                        {
                          item?.paymentStatus==="completed" ? <>Your payment via {item?.paymentLink} has been received successfully</>:<>
                          <a className='pay-now-btn' href={item?.paymentLink} target='_blank'>Pay Now</a>
                        <p>If the above button is not working then you can just copy the link below to make the payment.<br />{item?.paymentLink}</p>
                          </>
                        }
                      </div>
                    </div>
                  </div>
                </>
              )
            })
        }
        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              Family-based sponsorship
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div className='documents_wrapper'>
                <label>Birth Certificate -</label>
                <div className='upload_img_wrapper_div'>
                  {imageUpload && <div className='small_img_wrapper'>
                    <div className='small_img'>
                      <i class="fa-solid fa-circle-xmark"></i>
                      <img src={workpermit} />
                    </div>
                  </div>}
                  {!imageUpload && <>
                    <img src={upload} />
                    <h6>Click here to upload</h6>
                    <input onChange={(() => { setImageUpload(true) })} type='file' multiple />
                  </>}
                </div>

              </div>



            </div>
          </div>
        </div> */}

        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Employment-based immigration
            </button>
          </h2>
          <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div className='documents_wrapper'>
                <label>Birth Certificate -</label>
                <div className='upload_img_wrapper_div'>
                  {imageUpload && <div className='small_img_wrapper'>
                    <div className='small_img'>
                      <i class="fa-solid fa-circle-xmark"></i>
                      <img src={workpermit} />
                    </div>
                  </div>}
                  {!imageUpload && <>
                    <img src={upload} />
                    <h6>Click here to upload</h6>
                    <input onChange={(() => { setImageUpload(true) })} type='file' multiple />
                  </>}
                </div>

              </div>


            </div>
          </div>
        </div> */}

        {/* <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              Refugee and asylum claims
            </button>
          </h2>
          <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
            <div class="accordion-body">

              <div className='documents_wrapper'>
                <label>Birth Certificate -</label>
                <div className='upload_img_wrapper_div'>
                  {imageUpload && <div className='small_img_wrapper'>
                    <div className='small_img'>
                      <i class="fa-solid fa-circle-xmark"></i>
                      <img src={workpermit} />
                    </div>
                  </div>}
                  {!imageUpload && <>
                    <img src={upload} />
                    <h6>Click here to upload</h6>
                    <input onChange={(() => { setImageUpload(true) })} type='file' multiple />
                  </>}
                </div>

              </div>







            </div>
          </div>
        </div> */}

      </div>
    </>
  )
}

export default PaymentHistory
